import React from "react";
import "./Footer.scss";
import line from "../../images/Line 2.svg";

import logo from "../../images/resellerLogo.svg";
import lang from "../../images/language.png";
import { Link, useNavigate } from "react-router-dom";
const   Footer = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/terms");
  };
  const handleClick1=()=>{
   navigate("/privacy-policy");
  }
  return (
    <>
      
      <div className="footer" style={{ display: "flex" , flexDirection:"column"}}>
        <div className="footerrow">
          <div className="footercolumn">
          <img alt="" src={logo} className="footerlogo" />
          </div>
          <div className="LineOne"><img src={line}/></div>
          <div className="footercolumn">
            <p className="footerheading">About</p>
           <p className="footersublink"><Link className="footerlinks" to="/contactus">Contact Us</Link> </p>
           <p className="footersublink"><Link className="footerlinks" to="/aboutus">About Us</Link> </p>
           {/* <p className="footersublink"><Link className="footerlinks">Press</Link> </p> */}
          </div>
          <div className="footercolumn">
          <p className="footerheading">Help Center</p>
           <p className="footersublink"><Link className="footerlinks" to="/ProductsPricing-Policy">Payments</Link> </p>
           <p className="footersublink"><Link className="footerlinks" to="/shipping-policy">Shipping Policy</Link> </p>
           <p className="footersublink"><Link className="footerlinks" to="/return-policy">Return and Cancellation </Link> </p>
           <p className="footersublink"><Link className="footerlinks" to="/terms">Term of Use</Link> </p>
           <p className="footersublink"><Link className="footerlinks" to="/privacy-policy">Privacy Policy</Link> </p>
          </div>
          <div className="footercolumn">
          <p className="footerheading">Social</p>
         <p className="footersublink"><Link className="footerlinks" to="https://www.linkedin.com/company/onstara-pvt-ltd/" target="_blank" rel="noopener noreferrer">LinkedIn</Link> </p>
         <p className="footersublink"><Link className="footerlinks" to="https://www.facebook.com/onstaracom" target="_blank" rel="noopener noreferrer">Facebook</Link> </p>
         <p className="footersublink"><Link className="footerlinks" to="https://twitter.com/onstara_com" target="_blank" rel="noopener noreferrer">Twitter</Link> </p>
         <p className="footersublink"><Link className="footerlinks" to="https://www.instagram.com/onstaradotin/" target="_blank" rel="noopener noreferrer">Instagram</Link> </p>
          </div>
          
          <div className="Linetwo"><img src={line}/></div>

          {/* <div className="footercolumnline">
          <div className="line1"></div>
          </div> */}

          <div className="footercolumn">
          {/* <p className="footerheading">Corporates Office</p>
          <p className="footersublink">
            Infopark Phase 2, Padathikkara, <br/>Kakkanad, Kochi, Kerala 682303
          </p> */}
          <p className="footerheading">Corporates Office</p>
          <p className="footersublink">
          DOOR NO. AP 13/380G, SALAFI BUILDING,<br/> KURUDIMUKKU, KARAYADU POST, <br/>KOYILANDY, Kozhikode, <br/>Kerala, India. 673524.
          </p>
          </div>
        </div>
       
        <div className="footerrow">
        <div className="footercolumn">
            <p className="copyright">© Copyright 2020 -2023 Onstara.com</p>
         </div>
          
          {/* <p className="cookies">Cookies</p> */}
          <div className="footercolumn" >
            <div className="footerenglish">
              <img src={lang} alt="" />
              <p className="english">English</p>
            </div>
          </div>
          {/* <img src={languagearrow} className="langarrow" /> */}
        </div>
      </div>
    </>
  );
};

export default Footer;
